import React from 'react';
import {Control, RegisterOptions} from 'react-hook-form';
import cn from 'classnames';
import {t} from '@lingui/core/macro';

import Email from 'shared/ui/icons/Email';

import Input, {InputProps} from './Input';
import {getInputClassName, InputStateIcon, useInputState} from './inputState';

import styles from './Input.module.scss';

export interface InputEmailProps extends Omit<InputProps, 'type' >{
    control: Control<any>;
    validate?: boolean;
    name?: string;
}

const EMAIL_PATTERN: RegExp = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/; // eslint-disable-line

const InputEmail: React.FC<InputEmailProps> = ({control, validate = true, name = 'email', className, ...rest}) => {
    const {state} = useInputState({control, name, validate});

    const constraints: RegisterOptions = !rest.disabled
        ? {
            pattern: {value: EMAIL_PATTERN, message: t`Некорректный Email`},
            required: t`Не указан Email`,
        }
        : {};

    return (
        <div className={styles.input_container}>
            <div className={styles.icon}>
                <InputStateIcon state={state} defaultIcon={<Email/>}/>
            </div>
            <Input
                {...rest}
                type="text"
                id={name}
                name={name}
                placeholder={rest.placeholder ? rest.placeholder : t`Почта`}
                rules={constraints}
                className={cn(getInputClassName(styles, state, true), className)}
            />
        </div>
    );
};

export default React.memo(InputEmail);
